import styled, { useTheme } from "styled-components";
import { observer, inject } from "mobx-react";
import { Text } from "../UI";
import { useTranslation } from "react-i18next";

const Container = styled("div")(({ inLogin, theme }) => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  borderRadius: 12,
  borderWidth: `1.4px`,
  borderStyle: "solid",
  borderColor: inLogin ? theme.color.darkGray : "rgba(255, 255, 255, 0.50)",
  padding: 3,
  height: 35,
  width: 76,
  margin: inLogin ? "40px auto" : 25,
}));

const LangItem = styled("div")(() => ({
  cursor: "pointer",
  borderRadius: 12,
  textTransform: "uppercase",
  paddingInlineStart: 5,
  paddingInlineEnd: 5,
  textAlign: "center",
  width: 34
}));

const ChangeLanguage = ({ userStore, inLogin = false }) => {
  const theme = useTheme();
  const { t, i18n } = useTranslation("common");

  const changeLanguageHandler = (lang) => {
    i18n.changeLanguage(lang);
    userStore.setLanguage(lang);
  };

  return (
    <Container inLogin={inLogin}>
      <LangItem
        onClick={() => changeLanguageHandler("he")}
        style={{
          background:
            userStore.language === "he" ? theme.color.mainOrange : "none",
          border:
            userStore.language === "he"
              ? `1.4px solid rgba(255, 255, 255, 0.15)`
              : 0,
        }}>
        <Text.T2
          style={{
            lineHeight: "29px",
            color:
              userStore.language === "he"
                ? theme.color.white
                : inLogin
                ? theme.color.darkGray
                : theme.color.white,
          }}>
          {t("he")}
        </Text.T2>
      </LangItem>
      <LangItem
        onClick={() => changeLanguageHandler("en")}
        style={{
          background:
            userStore.language === "en" ? theme.color.mainOrange : "none",
        }}>
        <Text.T2
          style={{
            lineHeight: "29px",
            color:
              userStore.language === "en"
                ? theme.color.white
                : inLogin
                ? theme.color.darkGray
                : theme.color.white,
          }}>
          {t("en")}
        </Text.T2>
      </LangItem>
    </Container>
  );
};

export default inject("userStore")(observer(ChangeLanguage));
